import React, {useState} from 'react';
import AppAdminCard from './AppAdminCard.mjs';
import AppAdminUsersList from './AppAdminUsersList.mjs';
import AppAdminPublicTeamsList from './AppAdminPublicTeamsList.mjs';
import { useCTAL } from './CTAL_Hooks.js';

const DEBUG = false;

export default function AppAdminColumn() 
{
    const { app_user } = useCTAL();
    const [display_type, setDisplayType] = useState("users-list");
    const [display, setDisplay] = useState(<><AppAdminUsersList /></>);
 
    const show_display = (d_type, reset=false) => { 

        if ((display_type == d_type) && (!reset))
            return;

        switch (d_type)
        {
            case "users-list":
            default:
                setDisplay( <> <AppAdminUsersList /> </> ); 
                break;
            case "public-teams-list":
                setDisplay( <> <AppAdminPublicTeamsList /> </> ); 
                break;
        }

        setDisplayType(d_type);
    }

    return (
        <>
            <AppAdminCard show_display={show_display}/>
            {display}
        </>
    );
}